import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme: any) => ({
  font: {
    fontSize: 16,
    marginBottom: theme.spacing(3),
    color: theme.palette.common.white,
    whiteSpace: 'pre-wrap' as const,
  },
}));

type ParagraphTagProps = {
  text: string;
};

const ParagraphTag = ({ text }: ParagraphTagProps) => {
  const classes = useStyles();

  return (
    <Typography
      variant="body1"
      className={classes.font}
    >
      {text}
    </Typography>
  );
};

export default ParagraphTag;
